module.exports = __webpack_public_path__ + "img/delete-icon-new.792b08e8.svg";